<template>
    <div>
        <button v-if="!noActivator"
                      class="btn btn-extra-round btn-primary"
                      slot="activator"
                      @click="openModal">
                      Marketing
        </button>

        <modal v-model="show"
                max-width="900"
                content-class="leads-external-marketing-automation-management-modal modal-device"
                @input="emitInput"
                :has-padding="false">


          <div class="leads-external-marketing-automation-management-modal-body">
            <div class="leads-external-marketing-automation-management-modal-body-header">
              <h1 class="leads-external-marketing-automation-management-modal-body-title">{{ $t('message.leads.message.marketingSends') }}</h1>
            </div>

            <div class="leads-external-marketing-automation-management-modal-body-actions">
              <button class="btn btn-extra-round btn-primary"
                      @click="showingCreateModal = true">
                      {{ $t('message.leads.message.registerSend') }}
              </button>
            </div>

            <list class="tracker-list"
                :list="list"
                :infinite-id="infiniteId"
                :headers="headers"
                :loading="loading"
                @load="fetchData">
              <template slot="default"
                        slot-scope="slotProps">
                <leads-external-marketing-automation-manage-item :item="slotProps.item"
                                                                  @deleted="reload"
                                                                  @reload="reload"/>
              </template>
            </list>
          </div>

          <leads-external-marketing-automation-create-modal v-model="showingCreateModal"
                                                            @created="reload"
                                                            @edited="reload"
                                                            />

        </modal>
    </div>
</template>

<script>
import Modal from "@/components/generic/Modal";
import List from "@/components/generic/list/List";
import LeadsExternalMarketingAutomationCreateModal from "../../create/modal/LeadsExternalMarketingAutomationCreateModal.vue";
import LeadsExternalMarketingAutomationManageItem from "../item/LeadsExternalMarketingAutomationManageItem.vue";

export default {
  components: {
    Modal,
    List,
    LeadsExternalMarketingAutomationManageItem,
    LeadsExternalMarketingAutomationCreateModal,
},
  data() {
    return {
      list: [],
      infiniteId: +Date.now(),
      show: false,
      page: 0,
      showingCreateModal: false,
      loading: true,
      internalValue: false,
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    noActivator: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headers() {
      return [
        {text: this.$t('message.leads.message.dataBase'), value: "dataBase", sortable: false },
        { text: this.$t('message.leads.message.automationFlow'), value: "automationFlow", sortable: false },
        { text: this.$t('message.generics.message.status'), value: "status", sortable: false },
        { text: this.$t('message.leads.message.sendSchedule'), value: "scheduledDate", sortable: false },
        { text: this.$t('message.admGenerics.message.edition'), value: "edit", sortable: false },
      ]
    },
  },
  watch: {
    show(value) {
      if (value) {
        this.infiniteId++;
      }
    },
  },
  methods: {
    async fetchData($state) {
      try {
        this.loading = true;
        this.list = await this.$api.leads.listMarketingAutomationSends();
        $state.complete();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    openModal() {
      this.show = true;
    },
    hideModal() {
      this.emitInput(false);
      this.internalValue = false;
    },
    async emitInput(value) {
      if (!value) {
        this.internalValue = false;
      }
      this.$emit("input", value);
    },
    reload() {
      this.list = []
      this.infiniteId++
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.leads-external-marketing-automation-management-modal {
  .leads-external-marketing-automation-management-modal-body {
    padding: 20px 20px;

    .leads-external-marketing-automation-management-modal-body-title {
      text-align: center;
      font-size: 30px;
      font-weight: 600;
      margin-top: 0;
      margin-bottom: 40px;
      line-height: 1.1;
    }

    .leads-external-marketing-automation-management-modal-body-actions {
      margin-bottom: 15px;
    }

    .admin-marketing-credits-modal-body-credits {
      margin: 30px 0;
      max-height: 300px;
      overflow-y: scroll;
    }

    .admin-marketing-credits-modal-body-actions {
      display: flex;
      justify-content: space-between;

      .btn {
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
